import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CookieManager from '@/utils/CookieManager'
// 多语言
import i18n from './i18n'

// element
import ElementUI from 'element-ui'

import '@/assets/scss/element-variables.scss'

import 'element-ui/lib/theme-chalk/display.css'

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })

Vue.prototype.$cookie = CookieManager

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
